export default __webpack_public_path__ + "static/media/Metal007_1K_Color.d0867850.jpg";